import React, { useState } from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Loader2, KeyRound, Check } from 'lucide-react';
import { authAPI } from '../../lib/api';
import { toast } from 'sonner';

const AdminSettings = () => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    current_password: '',
    new_password: '',
    confirm_password: '',
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm_password) {
      toast.error('As senhas não coincidem');
      return;
    }
    if (form.new_password.length < 6) {
      toast.error('A nova senha deve ter pelo menos 6 caracteres');
      return;
    }
    setLoading(true);
    try {
      await authAPI.changePassword(form.current_password, form.new_password);
      toast.success('Senha alterada com sucesso!');
      setForm({ current_password: '', new_password: '', confirm_password: '' });
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao alterar senha');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-settings-page">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-slate-900">Configurações</h1>
        <p className="text-slate-600 mt-1">Gerencie sua conta e preferências</p>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 max-w-lg">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center">
            <KeyRound className="w-5 h-5 text-blue-600" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-slate-900">Alterar Senha</h2>
            <p className="text-sm text-slate-500">Atualize sua senha de acesso ao painel</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="current_password">Senha Atual</Label>
            <Input
              id="current_password"
              name="current_password"
              type="password"
              value={form.current_password}
              onChange={handleChange}
              required
              className="mt-1"
              data-testid="settings-current-password"
            />
          </div>
          <div>
            <Label htmlFor="new_password">Nova Senha</Label>
            <Input
              id="new_password"
              name="new_password"
              type="password"
              value={form.new_password}
              onChange={handleChange}
              required
              className="mt-1"
              data-testid="settings-new-password"
            />
          </div>
          <div>
            <Label htmlFor="confirm_password">Confirmar Nova Senha</Label>
            <Input
              id="confirm_password"
              name="confirm_password"
              type="password"
              value={form.confirm_password}
              onChange={handleChange}
              required
              className="mt-1"
              data-testid="settings-confirm-password"
            />
          </div>
          <Button
            type="submit"
            className="btn-primary w-full"
            disabled={loading}
            data-testid="settings-save-password"
          >
            {loading ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin mr-2" />
                Salvando...
              </>
            ) : (
              <>
                <Check className="w-4 h-4 mr-2" />
                Salvar Nova Senha
              </>
            )}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminSettings;
